<template>
    <v-card tile :loading="loading" class="e-libaray">
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <table>
                        <tr>
                            <td>
                                <v-btn class="mx-2 my-2" fab dark small color="primary" @click="addNewCategory">
                                    <v-icon>mdi-folder-plus</v-icon>
                                </v-btn><span class="ms-3"> {{ $t('AddFolder') }}</span>
                            </td>
                            <td width="10"></td>
                            <td>
                                <v-btn x-small fab color="primary" @click="addAttachmentDialog=true">
                                    <v-icon class="white--text">mdi-cloud-upload</v-icon>
                                </v-btn> <span class="ms-3"> {{ $t('AddAttachment') }}</span>
                            </td>
                            <td width="10"></td>
                            <td v-if="selectedCategoryId && canBeDeleted">
                                <v-btn x-small fab color="white" @click="deleteCategory(selectedCategoryId)">
                                    <v-icon color="error">mdi-delete</v-icon>
                                </v-btn> <span class="ms-3"> {{ $t('DeleteFolder') }}</span>
                            </td>
                            <td width="10"></td>
                            <td v-if="selectedCategoryId">
                                <v-btn x-small fab color="white" @click="editCategory()">
                                    <v-icon color="success">mdi-pen</v-icon>
                                </v-btn> <span class="ms-3"> {{ $t('EditFolder') }}</span>
                            </td>
                            <td width="10"></td>
                            <td v-if="selectedCategoryId">
                                <v-btn x-small fab color="white" @click="categoryPermissionDialog = true">
                                    <v-icon color="warning">mdi-shield-account</v-icon>
                                </v-btn> <span class="ms-3"> {{ $t('FolderPermissions') }}</span>
                            </td>
                        </tr>
                    </table>


                </v-col>
                <v-col cols="12" md="2">
                    <!--<v-card v-for="category in categories" :key="category.id" tile class="mb-2 text-center" :class="{ 'active' : category.id === selectedCategoryId }" @click="show(category.id)">
                    <div class="text-center pt-2">
                        <v-icon :color="category.id === selectedCategoryId ? 'white' : 'primary'">mdi-qrcode</v-icon>
                    </div>
                    <v-card-text><h3><b>{{ category.name }}</b></h3></v-card-text>
                </v-card>-->
                    <v-sheet dense class="pa-4 mt-4" color="secondary">
                        <v-text-field v-model="search" dense :label="$t('Search')" dark flat solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline" @input="handleSearch" />
                    </v-sheet>
                    <v-treeview ref="tree" :items="treecategories" :search="search" :filter="filter" activatable item-key="id" :open.sync="open">
                        <template v-slot:prepend="{ open }">
                            <v-icon>
                                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                        </template>
                        <template v-slot:label="{ item }">
                            <template>
                                <a class="d-block pa-2" @click="show(item)">
                                    {{ item.name }}
                                </a>
                            </template>
                        </template>
                    </v-treeview>
                </v-col>
                <v-divider vertical />
                <v-col>
                    <v-card tile>
                        <v-data-table :headers="headers" dense :items="result" :items-per-page="10">
                            <template v-slot:body>
                                <draggable v-model="result" tag="tbody" handle=".drag-handle" @end="onDragEnd">
                                    <tr v-for="item in result" :key="item.id">
                                        <td>
                                            <v-icon class="drag-handle" small>mdi-drag</v-icon>
                                        </td>
                                        <td><v-icon :color="iconColors[item.extension]" v-text="icons[item.extension.toLowerCase()]" /></td>
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.fileName }}</td>
                                        <td>{{ item.title }}</td>
                                        <td>{{ item.fileSize }}</td>
                                        <td>
                                            <v-icon color="teal" class="ms-3" @click="loadAttachment(item.recordId)"> mdi-eye</v-icon>
                                            <v-icon color="error" class="ms-3" @click="deleteItem(item.id)">mdi-delete</v-icon>
                                            <v-icon color="warning" class="ms-3" @click="setPermissions(item.id)">mdi-shield-account</v-icon>
                                        </td>
                                    </tr>
                                </draggable>
                            </template>
                        </v-data-table>

                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>

        <v-dialog v-if="addAttachmentDialog" v-model="addAttachmentDialog" width="600" persistent>
            <v-card>
                <v-toolbar dense dark color="primary" class="flex-grow-0">
                    <v-toolbar-title class="pa-0">
                        {{ $t('AddAttachment') }}
                    </v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="clear">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="attachmentForm" v-model="valid" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col cols="5">
                                    <v-file-input v-model="attachmentFile" required :rules="nameRules" accept=".docx, .pdf, .png, .jpg, .xlsx, .mp4" :label="$t('ChooseAttachment')" :multiple="false" :disabled="uploadingFile" />
                                </v-col>
                                <v-col cols="7">
                                    <v-text-field v-model="attachmentName" :label="$t('Name')" maxlength="50" :disabled="uploadingFile" @keydown.enter.prevent="addAttachment" />
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="secondary" tile class="white--text" small :disabled="uploadingFile" :loading="uploadingFile" @click="addAttachment">
                        {{ $t('Add') }}
                        <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn color="error" tile small :disabled="uploadingFile" @click="clear">
                        {{ $t('Cancel') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <CommonDialog v-model="attachmentDialog" :title="$t('Attachment')" css-content-class="pa-0" @input="$emit('input', false)">
            <v-container fluid class="stretch">
                <FileViewer :query="documentQuery" name="elibraryAttachment" />
            </v-container>
        </CommonDialog>

        <CommonDialog v-model="permissionDialog" v-if="permissionDialog" :title="$t('Permissions')" :fullscreen="false" width="35%" css-content-class="pa-0" @input="$emit('input', false)">
            <v-container fluid class="stretch">
                <GenericPermissions :itemId="selectedItem" @close="permissionDialog = false" :typeId="typeId"></GenericPermissions>
            </v-container>
        </CommonDialog>
        <CommonDialog v-model="categoryPermissionDialog" v-if="categoryPermissionDialog" :title="$t('Permissions')" :fullscreen="false" width="35%" css-content-class="pa-0" @input="$emit('input', false)">
            <v-container fluid class="stretch">
                <GenericPermissions :itemId="selectedCategoryId" @close="categoryPermissionDialog = false" :typeId="catTypeId"></GenericPermissions>
            </v-container>
        </CommonDialog>
        <v-form ref="elibraryCategoryForm" v-model="valid" lazy-validation>
            <CommonDialog v-model="dialog" :fullscreen="false" width="500" :title="title" show-action-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="eLibraryCategory.nameAr" :label="$t('NameAr')" :rules="nameRules" required />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="eLibraryCategory.nameEn" :label="$t('NameEn')" :rules="nameRules" required />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field type="number" v-model="eLibraryCategory.orderIndex" :label="$t('Order')" :rules="nameRules" required />
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="eLibraryCategory.parentId" :loading="loading" outlined item-text="name" item-value="id" :items="categories" :label="$t('ParentCategory')" dense />
                        </v-col>
                    </v-row>
                </v-container>

                <template v-slot:actions>
                    <v-btn v-if="!edit" color="primary" class="white--text" tile :disabled="loading" small @click="save()">
                        {{ $t("Add") }}
                    </v-btn>
                    <v-btn v-if="edit" color="primary" class="white--text" tile :disabled="loading" small @click="update()">
                        {{ $t("Update") }}
                    </v-btn>
                    <v-btn color="error" class="white--text" tile :disabled="loading" small @click="dialog = false; reset()">
                        {{ $t("Cancel") }}
                    </v-btn>
                </template>
            </CommonDialog>
        </v-form>
    </v-card>
</template>

<script>
    import FileViewer from '@/components/controls/FileViewer.vue'
    import CommonDialog from '@/components/controls/CommonDialog.vue'
    import GenericPermissions from '@/components/app/admin/GenericPermissions.vue'
    import draggable from 'vuedraggable'
    import { PermissionTypesEnum } from '@/helpers/constants/enumerations'
    import LookupsService from '@/services/LookupsService.js'
    import ElibraryService from '@/services/ElibraryService.js'
    import ElibraryCategoryService from '@/services/ElibraryCategoryService.js'
    export default {
        components: {
            FileViewer, CommonDialog, GenericPermissions, draggable
        },

        data() {
            return {
                typeId: PermissionTypesEnum.Elibrary,
                catTypeId: PermissionTypesEnum.ElibraryCategory,
                valid: true,
                edit: false,
                search:'',
                filter: null,
                title: '',
                open:null,
                dialog:false,
                isActive: true,
                loading: false,
                attachmentDialog: false,
                permissionDialog: false,
                categoryPermissionDialog:false,
                uploadingFile: false,
                addAttachmentDialog: null,
                attachmentFile: null,
                attachmentName: null,
                attachmentCategoryId: null,
                selectedCategoryId: null,
                canBeDeleted: false,
                selectedCategory: {},
                documentQuery: null,
                selectedItem: null,
                attachments: [],
                categories: [],
                treecategories:[],
                result: [],
                headers: [
                    { text: '', value: 'drag' },
                    { text: '', value: 'icon' },
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('FileName'), value: 'fileName' },
                    { text: this.$t('Title'), value: 'title' },
                    { text: this.$t('FileSize'), value: 'fileSize' },
                    { text: this.$t('Options'), value: 'options', width: '12%' }
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                icons: {
                    '.pdf': 'mdi-file-pdf-box mdi-30px',
                    '.docx': 'mdi-file-word mdi-30px',
                    '.xlsx': 'mdi-file-excel mdi-30px',
                    '.file': 'mdi-file mdi-30px',
                    '.png': 'mdi-file-image mdi-30px',
                    '.jpg': 'mdi-file-image mdi-30px',
                },
                iconColors: {
                    '.pdf': 'red darken-3',
                    '.docx': 'blue darken-3',
                    '.xlsx': 'green darken-3',
                    '.file': 'blue-grey',
                    '.png': 'orange darken-4',
                    '.jpg': 'orange darken-4',
                },
                eLibraryCategory: {
                    nameAr: '',
                    nameEn: '',
                    orderIndex:null,
                    parentId:null
                }
            }
        },

        created() {
            this.loadCategories()
        },

        methods: {
            onDragEnd(evt) {
                this.updateTableOrder()
            },
            async updateTableOrder() {
                ElibraryService.updateOrder(this.result)
                /*try {
                    // Make the server call here to save the updated order
                    const response = await fetch('/your-api-endpoint', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(this.result),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to update the order');
                    }

                    // Optionally handle response
                    console.log('Order updated successfully');
                } catch (error) {
                    console.error(error);
                }*/
            },
            addNewCategory() {
                this.dialog = true
                this.eLibraryCategory.parentId = this.selectedCategoryId
            },
            editCategory() {
                ElibraryCategoryService.getElibraryCategory(this.selectedCategoryId).then((res) => {
                    if (res.data) {
                        var selectedCategory = res.data
                        if (selectedCategory) {



                            this.eLibraryCategory = {
                                nameAr: selectedCategory.nameAr,
                                nameEn: selectedCategory.nameEn,
                                orderIndex: selectedCategory.orderIndex,
                                parentId: selectedCategory.parentId
                            }
                            this.edit = true
                            this.dialog = true
                        }
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
                
            },
            handleSearch(input) {
                if (input) {
                    this.$refs.tree.updateAll(true)
                } else {
                    this.$refs.tree.updateAll(false)
                }
            },
            clear() {
                this.addAttachmentDialog = false
                this.attachmentFile = null
                this.attachmentName = null
                this.attachmentTypeId = null
            },

            loadCategories() {
                LookupsService.listElibraryCategories().then((res) => {
                    if (res.data) {
                        this.categories = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
                ElibraryCategoryService.listElibraryCategories().then((res) => {
                    if (res.data) {
                        this.treecategories = res.data
                        this.selectedCategoryId = res.data[0].id
                        this.selectedCategory = res.data[0]
                        this.canBeDeleted = res.data[0].parentId != null && res.data[0].parentId!=undefined
                        this.eLibraryCategory.parentId = this.selectedCategoryId
                        this.loadCategory(this.selectedCategoryId)
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            addAttachment() {
                if (this.$refs.attachmentForm.validate()) {
                    let formdata = new FormData()
                    formdata.append('attachment', this.attachmentFile)
                    formdata.append('filename', this.attachmentName == null ? '' : this.attachmentName)
                    formdata.append('elibraryCategoryId', this.selectedCategoryId)
                    this.uploadingFile = true
                    ElibraryService.addAttachment(formdata).then((res) => {
                        if (res.success) {
                            this.loadCategory(this.selectedCategoryId)
                            this.$root.$notification(this.$t('FileSavedSuccess'), 'success')
                        }
                        this.clear()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.uploadingFile = false
                    })
                }
            },

            loadCategory(id) {
                this.loading = true
                ElibraryService.loadCategory(id).then((res) => {
                    if (res.data) {
                        this.result = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            loadAttachment(recordId) {
                ElibraryService.getAttachment(recordId).then(response => {
                    this.documentQuery = response.data
                    this.attachmentDialog = true
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

            show(category) {
                this.selectedCategoryId = category.id
                this.canBeDeleted = this.treecategories[0].id != category.id
                this.selectedCategory = category
                this.eLibraryCategory.parentId = this.selectedCategoryId
                this.loadCategory(category.id)
            },

            async deleteItem(attachmentId) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    ElibraryService.deleteElibrary(attachmentId)
                        .then(() => {
                            this.loadCategory(this.selectedCategoryId)
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
            async deleteCategory(categoryId) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete') + ': ' + this.selectedCategory.name)) {
                    this.loading = true
                    ElibraryCategoryService.deleteElibraryCategory(categoryId)
                        .then(() => {
                            this.loadCategories()
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },
            setPermissions(itemId) {
                this.selectedItem = itemId
                this.permissionDialog = true
            },
            save() {
                if (this.$refs.elibraryCategoryForm.validate()) {
                    ElibraryCategoryService.addElibraryCategory(this.eLibraryCategory).then((res) => {
                        this.loadCategories()
                        this.reset()
                        this.dialog = false
                        this.$refs.elibraryCategoryForm.resetValidation()
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            update() {
                if (this.$refs.elibraryCategoryForm.validate()) {
                    ElibraryCategoryService.updateElibraryCategory(this.selectedCategoryId, this.eLibraryCategory).then((res) => {
                        this.dialog = false
                        this.loadCategories()
                        this.reset()
                        this.edit = false
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            reset() {
                this.eLibraryCategory.nameAr = ''
                this.eLibraryCategory.nameEn = ''
                this.eLibraryCategory.orderIndex = null
                this.eLibraryCategory.parentId = null
            },
        }
    }
</script>

<style>
    .e-libaray .active h3 { color: #fff !important }

    .e-libaray .active i { color: #fff !important }

    .stretch { height: 100% }
</style>